import React from 'react'
import clsx from 'clsx'
import { ArrowDown2 } from 'iconsax-react'

import AddColor from '../../Controls/Add/AddColour'
import Dropdown from '../../../../components/atoms/Dropdown'

import { useSettingsEdit } from '../../../../providers/SettingsEditProvider'

import useStyles from '../styles'

const MAP_BASE_API = {
  critical: 'Critical',
  low: 'Low'
}

const MAP_BASE = {
  None: null,
  Critical: 'critical',
  Low: 'low'
}

const OPTIONS = ['None', 'Critical', 'Low']

interface PriorityEditProps {
  obj: any
  superType: string
}

const PriorityEdit: React.FC<PriorityEditProps> = ({ obj, superType }) => {
  const [color, setColor] = React.useState(obj.colour)
  const [name, setName] = React.useState(obj.name)
  const [base, setBase] = React.useState(
    obj.base_priority ? MAP_BASE_API[obj.base_priority] : 'None'
  )

  const classes = useStyles()

  const { setSave } = useSettingsEdit()

  React.useEffect(() => {
    if (color || name || base) {
      let existing = { ...obj }

      existing = {
        ...existing,
        colour: color,
        name: name,
        base_priority: MAP_BASE[base]
      }

      setSave(existing)
    }
    // adding obj here as a dependency will create infinite rerenders
    // eslint-disable-next-line
  }, [color, name, base, setSave])

  return (
    <div className={classes.complexEdit}>
      <div style={{ cursor: 'pointer' }}>
        <AddColor prevColor={color} saveColor={setColor} />
      </div>

      {superType !== 'user' && (
        <div className={classes.complexEdit}>
          <Dropdown
            options={OPTIONS}
            selected={base}
            onSelect={val => setBase(val)}
            hideAdd
            hideClose
            stringOnly
          >
            <div className={classes.editDropdown}>
              <span style={{ paddingRight: '1rem' }}>{base ?? 'Open'}</span>
              <ArrowDown2 className={classes.icon} />
            </div>
          </Dropdown>
        </div>
      )}

      <input
        value={name}
        onChange={e => setName(e.target.value)}
        className={clsx(classes.input, classes.shortInput)}
        maxLength={25}
      />
    </div>
  )
}

export default PriorityEdit
